import store from '@/store'
import router from "@/router";
import {findAttributeOnSiteInfo} from './FindAttributeOnSiteInfo'
import {generateHash} from '../Modules/ShoppingCart';
import {toast} from "./Notification";
import {formatNumber, flatten} from "./Converter";
import {isProductActive, getNowString} from "../Modules/Timing";
import {defaultProductImage} from "../Modules/Product";
import {toastTranslationHelper} from "./ToastTranslationHelper";

export const quantityStatus = (product) => {
    return product.quantity_status == 0
}

export const quantityChecker = (quantity, product, sub_product = null) => {
    let productQuantity = findProductQuantity(product, sub_product);
    if (product.variation == 1) {
        return productQuantity >= quantity
    } else {

        if (productQuantity >= quantity) {
            return true
        }

    }
    return false
}

export const checkCallingMode = (product) => {
    return product.price == null && product.variation == 0
}

export const bulkSetter = (product) => {
    let order_product = findProductOnAuthenticatedOrder(product)
    let bulks = product.bulks

    if (bulks == undefined) return false

    let quantity = 1
    if (order_product.quantity !== undefined) {
        quantity = order_product.quantity;
    } else {
        quantity = 1;
    }

    let selectedItems = []

    bulks.forEach(item => {
        item['sub_price'] = item['price'] - item['offer']
        if (item['q_1'] <= quantity && (item['q_2'] >= quantity || item['q_2'] === null)) {
            selectedItems.push(item)
        }

    })

    selectedItems.sort(function (a, b) {
        return a.price - b.offer;
    });


    return selectedItems.length > 0 ? selectedItems : false
}

export const countProductFeature_deprecate = (product) => {
    let count = 0;
    for (let feature in product.features) {
        feature = product.features[feature]
        if (feature.feature_values.link_feature_value == null) {
            count = 1 > count ? 1 : count
        } else {
            count = 2 > count ? 2 : count
        }
    }
    return count
}

export const findProductOnAuthenticatedOrder = (product, sub_product = null) => {
    const order = store.getters['ShoppingCart/getSidebarBasketData']
    let result = false;
    if (order.items !== undefined) {
        order.items.forEach(item => {
            if (item.product.id === product.id) {
                if (product.variation == 0 && sub_product == null) {
                    result = item
                } else {
                    if (item.sub_product == sub_product) {
                        result = item
                    }
                }
            }
        })
    }
    return result
}

export const findProductOnLocalStorage = (product, sub_product) => {
    if (localStorage.getItem('products') !== null) {
        let products = JSON.parse(localStorage.getItem('products'));
        for (let i in products) {
            let item = products[i];
            if (item.variation == 1 && item.id == product.id && item.sub_product_id == sub_product || item.variation == 0 && item.id == product.id) {
                return item;
            }
        }
        return false
    } else {
        return false
    }
}

export const findSubProductOnProduct = (product, sub_product) => {
    if (sub_product == null) return null
    if (product.variation == 0 || product.variation == 2) return null
    return product.feature_product.find(item => item.id == sub_product)
}

export const subProductName_deprecate = (product, sub_product) => {
    let name = ''

    if (product.variation == 1) {

        const product_features = product.features;

        for (let feature in product_features) {
            feature = product_features[feature]
            if (feature.feature_values.link_feature_value != null && feature.feature_values.link_feature_value.id == sub_product) {
                const feature_attributes_id_1 = feature.feature_values.feature_attribute_id
                const feature_attributes_1 = feature.feature_attributes

                feature_attributes_1.forEach(item => {

                    if (item.id == feature_attributes_id_1) {
                        name += item.value
                    }
                })


                const feature_attributes_id_2 = feature.feature_values.link_feature_value.feature_attribute_id
                const feature_attributes_2 = feature.feature_values.link_feature.feature_attributes

                feature_attributes_2.forEach(item => {
                    if (item.id == feature_attributes_id_2) {
                        name += ' - ' + item.value
                    }
                })


            }

            if (feature.feature_values.link_feature_value == null && feature.feature_values.id == sub_product) {
                const feature_attributes_id_1 = feature.feature_values.feature_attribute_id
                const feature_attributes_1 = feature.feature_attributes

                feature_attributes_1.forEach(item => {

                    if (item.id == feature_attributes_id_1) {
                        name += item.value
                    }
                })
            }


        }

    }

    return name

}

export const calculatePriceAndOffer = (product, sub_product_id) => {
    /* todo implement bulk for unauthenticated and variation product */
    let offer = 0
    let price = 0

    let isAuthenticated = store.getters['User/isAuthenticated']

    if (product.variation == 1) {
        let feature = findSubProductOnProduct(product, sub_product_id)

        price = feature.price
        offer = feature.offer

    } else {

        offer = product.offer
        price = product.price

        const bulks = bulkSetter(product)

        if (bulks !== false) {
            let bulk = bulks.slice(-1)[0];
            return {
                offer: bulk['offer'],
                price: bulk['price'],
                sub_product: null,
            }
        }

        if (checkProductHaveFormula(product)) {
            price = product.min_price
        }


    }

    return {
        offer: offer,
        price: price,
        sub_product: sub_product_id,
    }


}

export const shoppingCartLink = () => {
    let isAuthenticated = store.getters['User/isAuthenticated']
    return isAuthenticated ? 'ShoppingCart' : 'UnAuthenticatedShoppingCart'
}

export const checkProductOnShoppingCart = (product, sub_product = null) => {
    const isAuthenticated = store.getters['User/isAuthenticated']
    if (isAuthenticated) {
        return findProductOnAuthenticatedOrder(product, sub_product) !== false
    }
    return findProductOnLocalStorage(product, sub_product) !== false
}

export const basketAddItem = (product, sub_product) => {
    if (store.getters['User/isAuthenticated'] == false) {
        toast("خطا", "برای اضافه کردن محصول به سبد ابتدا باید ثبت نام کنید", 'danger');
    } else {
        let form;
        if (product.variation == 1) {
            form = {product: [{id: product.id, sub_product: sub_product}]};
        } else {
            form = {product: [{id: product.id}]};
        }

        store.dispatch("ShoppingCart/addItem", form)
        if (product.is_digital == 1) {
            router.push({'name': 'ShoppingCart'});
        }
    }
}

export const addToCart = async (product, sub_product) => {
    let isAuthenticated = store.getters["User/isAuthenticated"]
    if (isAuthenticated) {
        await basketAddItem(product, sub_product)
    } else if (findAttributeOnSiteInfo('cartType')[0] == 0 && !isAuthenticated) {
        await addUnAuthItem(product, sub_product)
    } else {
        toast("خطا", "برای اضافه کردن محصول به سبد ابتدا باید ثبت نام کنید", 'danger');
    }

}

export const subProductImage = (product, sub_product) => {
    if (product.variation == 0 || product.variation == 2) {
        return product.thumbnail == null ? defaultProductImage : product.thumbnail
    }

    sub_product = findSubProductOnProduct(product, sub_product)
    const image = sub_product.image == null ? defaultProductImage : sub_product.image

    return image
}

export const countItemsOnShoppingCart = () => {
    const isAuth = store.getters['User/isAuthenticated'];
    if (isAuth) {
        const orderCount = store.getters['ShoppingCart/getSidebarBasketData']
        return orderCount.length !== 0 && orderCount.items !== undefined ? orderCount.items.length : 0
    }
    const localProducts = localStorage.products;
    return localProducts !== undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
}

/* return range of price in variation product  */
export const getProductPrice_deprecate = (product, onlyNumbers = false) => {

    if (product.variation == 0) {
        return formatNumber(product.price)
    } else {

        let productFeatures = product.features;
        let subProductPaths = [];
        let items = flatten(product.features)
        Object.entries(items).forEach(item => {
            const key = item[0]
            const value = item[1]
            let subProductPath = key.split('.');
            if (subProductPath.indexOf('sub_product') > -1 && value == 1) {
                subProductPaths.push(subProductPath)
            }
        })

        let prices = [];


        subProductPaths.forEach(item => {
            item.pop() // remove last key

            let productFeaturesTemp = Object.assign({}, productFeatures)

            item.forEach(path => {
                productFeaturesTemp = productFeaturesTemp[path]
            })

            prices.push(productFeaturesTemp.price)

        })

        if (prices.length == 0) {
            return false
        }

        const min = Math.min.apply(null, prices);
        const max = Math.max.apply(null, prices);

        if (onlyNumbers) {
            return [min, max]
        }


        return `${formatNumber(min)} - ${formatNumber(max)}`
    }
}

/* return range of Offer in variation product  */
export const getProductOffer_deprecate = (product, onlyNumbers = false) => {
    let offers = [];
    let items = flatten(product.features)
    Object.entries(items).forEach((item, index) => {
        if (item[0].indexOf('offer') > -1) {
            let tempOffer = parseInt(item[1])
            if (!isNaN(tempOffer) && tempOffer > 0) {
                offers.push(tempOffer)
            }
        }
    })
    if (offers.length == 0) {
        return false
    }

    const min = Math.min.apply(null, offers);
    const max = Math.max.apply(null, offers);

    if (onlyNumbers) {
        return [min, max]
    }

    return `${formatNumber(min)} - ${formatNumber(max)}`
}

/* unauthenticated functions  */


export const removeProductFromLocalStorage = (product, sub_product = null) => {
    const productHash = findProductOnLocalStorage(product, sub_product)['productHash']
    let products = JSON.parse(localStorage.getItem('products'));
    delete products[productHash];
    localStorage.setItem('products', JSON.stringify(products));

    if (Object.keys(JSON.parse(localStorage.getItem('products'))).length == 0) {
        localStorage.removeItem('products')
    }
    return true
}

export const findProductQuantity = (product, sub_product) => {
    let quantity;
    if (product.variation == 2) {
        return 1
    }
    if (product.variation == 1) {
        sub_product = findSubProductOnProduct(product, sub_product)
        quantity = (sub_product.quantity == null ? Infinity : sub_product.quantity)
    } else {
        quantity = product.quantity;
        if (product.variation == 0 && quantity == null) {
            quantity = Infinity;
        }
    }
    return quantity
}

export const productShapeOnLocalStorage = (quantity, productHash, product, sub_product = null, reservationData = null) => {
    return {
        "id": product.id,
        "variation": product.variation,
        "product": product.raw_link,
        "price": product.price,
        "discount": product.offer,
        "productHash": productHash,
        "sub_product_id": sub_product,
        "quantity": quantity,
        "reservationData": reservationData
    }
}

export const addUnAuthItem = async (product, sub_product, reservationData = null, withoutRedirect = false) => {

    const vueInstance = window.vueInstance;

    // if we don't have products key on local storage we initialize it
    if (localStorage.getItem('products') === null) {
        localStorage.setItem('products', "{}");
    }

    let products = JSON.parse(localStorage.getItem('products'));

    if (quantityChecker(1, product, sub_product)) {
        const form = {
            selected_date_time: getNowString(),
            timable_type: 'product',
            timable_id: product.id,
        }

        console.log(vueInstance, 'outside')

        await store.dispatch('Timing/checkTiming', form).then((res) => {
            const status = res.data.data.status;
            if (status) {
                let newProductHash = generateHash();

                if (reservationData != null) {
                    console.log(reservationData)
                    reservationData = {
                        reservation_start: reservationData.reservation[0].start,
                        reservation_end: reservationData.reservation[0].end,
                        extra_options: reservationData.reservation_extra_options
                    }
                }

                products[newProductHash] = productShapeOnLocalStorage(1, newProductHash, product, sub_product, reservationData);

                toastTranslationHelper('محصول با موفقیت به سبد اضافه شد', 'shopping_cart.add_to_cart_messages.success')


                localStorage.setItem('products', JSON.stringify(products));

                if (product.is_digital == 1 && !withoutRedirect) {
                    router.push({'name': 'UnAuthenticatedShoppingCart'});
                }
                return true
            } else {

                toastTranslationHelper('زمان خرید محصول به پایان رسیده است',
                    'shopping_cart.add_to_cart_messages.out_of_time', 'danger')


                return false
            }

        })
    } else {

        toastTranslationHelper('تعداد موجودی درخواستی در دسترس نیست', 'shopping_cart.add_to_cart_messages.out_of_time', 'danger')


    }


}

export const updateUnAuthItemQuantity = (quantity, product, sub_product = null) => {
    quantity = parseInt(quantity)
    if (isNaN(quantity)) {
        toast("مقدار عددی وارد کنید", "مقدار عددی وارد کنید", 'danger');
        return;
    }


    let products = JSON.parse(localStorage.getItem('products'));
    let productOnStorage = findProductOnLocalStorage(product, sub_product)


    if (!quantityChecker(quantity, product, sub_product)) {
        toast("تعداد انتخاب شده موجود نمیباشد", "تعداد انتخاب شده موجود نمیباشد", 'danger');
        return;
    }

    let productHash = productOnStorage.productHash

    products[productHash] = productShapeOnLocalStorage(quantity, productHash, product, sub_product);
    localStorage.setItem('products', JSON.stringify(products));
    toast("تعداد محصول با موفقیت به روز شد", "تعداد محصول با موفقیت به روز شد");
    return true
}

/* return product on order, we can't access the quantity of item in order */
export const orderProduct = (product, sub_product) => {
    let isAuthenticated = store.getters['User/isAuthenticated']

    if (isAuthenticated) {
        return findProductOnAuthenticatedOrder(product, sub_product)
    } else {
        return findProductOnLocalStorage(product, sub_product)
    }
}

export const changeItemQuantity = async (order, quantity, product, sub_product = null, mode = 'up') => {
    let isAuthenticated = store.getters['User/isAuthenticated']

    // set quantity value
    if (mode === 'up') {
        quantity += 1
    } else if (mode === 'down') {
        quantity -= 1
    }

    if (isAuthenticated) {


        const form = {
            order_product_id: orderProduct(product, sub_product).id,
            quantity: quantity,
            order_id: order.id,
            user_id: order.user.id,
        };

        store.dispatch("ShoppingCart/changeQuantityWithoutState", form)
            .then(res => {
                let data = res.data.data;
                const deliveryBoundary = data.delivery_free_boundary;
                const delivery_price = response.delivery_amount;
                const freeCities = data.free_cities_delivery;
                const payDescript = data.description_on_payment_page[0].value;

                let response = res.data.data;
                this.$store.commit("ShoppingCart/setSidebarBasketData", response);
                this.$store.commit("ShoppingCart/setUserOrderUnpaidItems", response.items);
                this.$store.commit("ShoppingCart/setDeliveryPrice", delivery_price);
                this.$store.commit("ShoppingCart/setDeliveryBoundary", deliveryBoundary);
                this.$store.commit("ShoppingCart/setFreeCities", freeCities);
                this.$store.commit("ShoppingCart/setpayDescript", payDescript);


            })
            .catch(error => {
                store.dispatch("ShoppingCart/userOrderUnpaid")
            })
    } else {
        updateUnAuthItemQuantity(quantity, product, sub_product)
    }
}

export const deleteItem = (order, product, sub_product = null) => {
    let isAuthenticated = store.getters['User/isAuthenticated']
    if (isAuthenticated) {
        store.dispatch("ShoppingCart/removeItem", {
            order_product_id: orderProduct(product, sub_product).id,
            order_id: order.id
        })
    } else {
        removeProductFromLocalStorage(product, sub_product)
    }

}

export const isCartTypeOnUnAuthenticated = () => {
    /*
    * this method define userAccess to addToCart button in single product
    * base on cartType on Site-info
    * */
    const isAuthenticated = store.getters['User/isAuthenticated']
    const cartType = findAttributeOnSiteInfo('cartType')[0];
    return cartType == 0 || (cartType == 1 && isAuthenticated)
}


export const productReservationData = (product) => {
    const reservationRule = JSON.parse(product.reservation_rule.json)
    const reservations = product.reservation
    return {
        reservationRule: reservationRule,
        reservations: reservations, // reserved times
    }
}

export const productReservationRange = (product) => {
    let productData = productReservationData(product)
    let reservations = productData.reservations
    let result = []

    reservations.forEach(item => {
        result.push(item.date_time_taken_start)
        result.push(item.date_time_taken_end)
    })

    result.sort((a, b) => {
        // Convert the strings to Date objects
        let dateA = new Date(a);
        let dateB = new Date(b);
        // Compare the dates and return -1, 0 or 1
        if (dateA < dateB) {
            return -1;
        } else if (dateA > dateB) {
            return 1;
        } else {
            return 0;
        }
    })

    return {
        'min': result[0],
        'max': result[1]
    }
}

export const reservationMetaTranslation = (product) => {
    let productData = productReservationData(product)
    let selectedMeta = product.meta
    let reservationRule = productData.reservationRule
    let extraItems = reservationRule.extra_items

    let result = {};
    selectedMeta.forEach(item => {
        let findItemOnExtraItems = extraItems.find(obj => obj.id == item.name)

        let selectedExtraItems = findItemOnExtraItems.items.find(obj => {
            return obj.id == item.value
        });

        // find item on items of extra Items options
        result[findItemOnExtraItems.properties.title] = selectedExtraItems.name
    })

    return result
}

export const productHashToLocalStorageItem = (hash) => {
    let localStorageProducts = JSON.parse(localStorage.getItem('products'))
    let result = null
    Object.entries(localStorageProducts).forEach((item, key) => {
        if (item[0] === hash) {
            result = item[1]
        }
    })

    return result
}

export const checkProductHaveFormula = (product) => {
    let productFeatures = product.feature_product
    let result = false;


    if (productFeatures == null || productFeatures == undefined || Object.keys(productFeatures).length === 0) {
        return result // false
    }

    productFeatures.forEach(item => {
        if (item.feature != null && item.feature.type == 'formula') {
            result = true
        }
    })


    return result

}


export const shoppingCartFunctions = {
    addUnAuthItem,
    checkCallingMode,
    countProductFeature_deprecate,
    findProductOnAuthenticatedOrder,
    findProductOnLocalStorage,
    productHashToLocalStorageItem,
    quantityStatus,
    shoppingCartLink,
    checkProductOnShoppingCart,
    addToCart,
    basketAddItem,
    formatNumber,
    isProductActive,
    findSubProductOnProduct,
    quantityChecker,
    findProductQuantity,
    calculatePriceAndOffer,
    subProductName_deprecate,
    subProductImage,
    changeItemQuantity,
    deleteItem,
    isCartTypeOnUnAuthenticated,
    productReservationData,
    productReservationRange,
    reservationMetaTranslation,
    checkProductHaveFormula,
}
